var fontFamilyFallback = "'Arial', 'Trebuchet MS', sans-serif";
/**
 * https://lineto.com/typefaces/circular
 */
var fontFamilyBook = "'Circular-Book', ".concat(fontFamilyFallback);
var fontFamilyBookItalic = "'Circular-Italic', ".concat(fontFamilyFallback);
var fontFamilyMedium = "'Circular-Medium', ".concat(fontFamilyFallback);
var fontFamilyMediumItalic = "'Circular-Italic-Medium', ".concat(fontFamilyFallback);
var fontFamilyBold = "'Circular-Bold', ".concat(fontFamilyFallback);
/** Help text, h6 uppercase */
var fontSizeXxSmall = 12;
/** Tooltips */
var fontSizeXSmall = 13;
/** Buttons, labels, paragraphs, h5 */
var fontSizeSmall = 14;
/** h4 */
var fontSizeMedium = 16;
/** h3 */
var fontSizeLarge = 18;
/** h2 */
var fontSizeXLarge = 28;
/** h1 */
var fontSizeXxLarge = 40;
var fontWeightBook = 400;
var fontWeightMedium = 500;
var fontWeightBold = 700;
export { fontFamilyBold, fontFamilyBook, fontFamilyBookItalic, fontFamilyFallback, fontFamilyMedium, fontFamilyMediumItalic, fontSizeLarge, fontSizeMedium, fontSizeSmall, fontSizeXLarge, fontSizeXSmall, fontSizeXxLarge, fontSizeXxSmall, fontWeightBold, fontWeightBook, fontWeightMedium };